var CryptoJS = require("crypto-js");

const merchantKey = process.env.REACT_APP_MERCHANT_KEY || "1234567890";
const merchantId = process.env.REACT_APP_MERCHANT_ID || "1234567890";
function generateNonce() {
  return Math.random().toString(36).substring(2); // Random string
}

function generateSignature(queryString, merchantKey) {
  const hmac = CryptoJS.HmacSHA256(queryString, merchantKey);
  return CryptoJS.enc.Base64.stringify(hmac);
}

function sortObject(obj) {
  return Object.keys(obj)
    .sort()
    .reduce((acc, key) => {
      acc[key] = obj[key];
      return acc;
    }, {});
}

export default async function getSignature() {
  const myToken = localStorage.getItem("token");
  try {
    const timestamp = Math.floor(Date.now() / 1000);
    const nonce = generateNonce();
    const params = {
      "x-api-key": merchantId,
      "X-Timestamp": timestamp,
      "X-Nonce": nonce,
    };

    const sortedParams = sortObject(params);
    const queryString = new URLSearchParams(sortedParams).toString();
    const signature = generateSignature(queryString, merchantKey);
    // console.log("signature",signature)

    const headers = {
      // NOTE: do not hardcode Content-Type here. The app sends JSON object
      // bodies (and FormData for uploads); letting axios set the header
      // automatically produces `application/json` (or multipart with the
      // correct boundary), which the backend body-parsers expect. Forcing
      // `application/x-www-form-urlencoded` mis-parses JSON bodies and breaks
      // login/topup/etc.
      "x-api-key": merchantId,
      "X-Timestamp": timestamp,
      "X-Nonce": nonce,
      "X-Sign": signature,
      "authorization": `${myToken}`,
    };
    // console.log("haders",headers);
    return headers;
  } catch (e) {
    // console.log(e);
  }
}
